import React, { useEffect, useState, useContext } from 'react';
import { context } from '../../../context';
import { DropDown } from '../../atoms';
import { Select, Option } from './Styled';
import { useHandleFilter } from '../../../hooks';

export interface SelectFilterProps {
  filters?: number[];
  allNotes?: string;
  ellipsis?: boolean;
  left?: '0px';
  right?: '0px';
  fullWidth?: boolean;
  dispatchMetrics: (metricName: string, data: any) => void;
}

const SelectFilter = (props: SelectFilterProps) => {
  const { filters, allNotes, ellipsis, left, right, dispatchMetrics } = props;
  const { queryParam, data } = useContext<any>(context);
  const { handleFilter } = useHandleFilter();
  const [selected, setSelected] = useState<string[]>([]);
  const label = selected?.length ? `notas ${selected[0]} estrelas` : allNotes;
  const onChange = ({ target }: { target: { name: string } }) => {
    handleFilter({ rating: [target.name] });
    dispatchMetrics('event:track', {
      category: 'avaliacao-pdp',
      action: 'filtro',
      label: `${target.name}-estrela` + `${target.name !== '1' ? 's' : ''}`,
    });
  };
  const resetFilter = () => setSelected([]);
  useEffect(() => {
    setSelected(queryParam.rating);
  }, [queryParam]);

  const renderOptions = filters?.map((filter: number) => {
    const str = filter.toString();
    const label = `notas ${str} estrela` + `${str !== '1' ? 's' : ''}`;
    const id = str;
    const select = selected[0];
    const key = `rating_${str}`;
    const disabled = !data?.rating?.distribution[key].count;

    return (
      <Option key={str}>
        <input disabled={disabled} type="checkbox" id={id} name={str} onChange={onChange} checked={select === str} />
        <label htmlFor={id}>{label}</label>
      </Option>
    );
  });

  return (
    <>
      <DropDown label={label} oneClick ellipsis={ellipsis} left={left} right={right}>
        <Select>
          <Option>
            <input type="checkbox" id={allNotes} name={allNotes} onChange={resetFilter} checked={!selected.length} />
            <label htmlFor={allNotes}>{allNotes}</label>
          </Option>
          {renderOptions}
        </Select>
      </DropDown>
    </>
  );
};

SelectFilter.defaultProps = {
  filters: [5, 4, 3, 2, 1],
  allNotes: 'todas as notas',
};

export default SelectFilter;
export { SelectFilter };
